import React from "react";
import SEOHead from "@/components/SEOHead";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ShieldCheck, HeartHandshake, AlertTriangle, UserCheck, Sparkles } from "lucide-react";

const UsoResponsavelPage: React.FC = () => {
  const itens = [
    {
      icon: <Sparkles className="h-5 w-5" />,
      title: "Uso Recreativo",
      desc: "A plataforma deve ser utilizada como ferramenta de entretenimento e estudo de padrões.",
    },
    {
      icon: <ShieldCheck className="h-5 w-5" />,
      title: "Apoio Estatístico",
      desc: "Nossas análises servem como apoio estratégico — não substituem decisão pessoal do usuário.",
    },
    {
      icon: <AlertTriangle className="h-5 w-5" />,
      title: "Ausência de Garantias",
      desc: "Nenhum resultado é garantido. Loterias e Jogo do Bicho envolvem fatores aleatórios.",
    },
    {
      icon: <UserCheck className="h-5 w-5" />,
      title: "Responsabilidade do Usuário",
      desc: "Aposte com moderação, dentro do seu orçamento e apenas se tiver idade legal permitida.",
    },
    {
      icon: <HeartHandshake className="h-5 w-5" />,
      title: "Jogo Consciente",
      desc: "Se o ato de apostar deixar de ser entretenimento, busque ajuda profissional especializada.",
    },
  ];

  return (
    <>
      <SEOHead
        title="Uso Responsável — IA Palpite Guru"
        description="Diretrizes de uso responsável do IA Palpite Guru: entretenimento, apoio estatístico, ausência de garantias e responsabilidade do usuário."
        keywords="uso responsável jogo do bicho, jogo consciente, apostas responsáveis, ia palpite guru responsabilidade"
        canonical="/uso-responsavel"
      />
      <div className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5">
        <div className="container mx-auto px-4 py-12 max-w-4xl">
          <div className="text-center mb-10">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-500 to-primary text-white mb-5 shadow-lg">
              <ShieldCheck className="h-7 w-7" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold mb-3 text-foreground">
              Uso Responsável
            </h1>
            <p className="text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              O IA Palpite Guru promove o uso consciente da plataforma. Conheça nossas diretrizes.
            </p>
          </div>

          <div className="grid gap-4">
            {itens.map((item) => (
              <Card key={item.title} className="bg-card/60 backdrop-blur border-border">
                <CardContent className="p-5 flex items-start gap-4">
                  <div className="shrink-0 w-10 h-10 rounded-lg bg-primary/15 text-primary flex items-center justify-center">
                    {item.icon}
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground mb-1">{item.title}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">{item.desc}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <Card className="mt-8 border-amber-500/30 bg-amber-500/5">
            <CardHeader>
              <CardTitle className="text-base text-foreground">Aviso Importante</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground leading-relaxed">
              O IA Palpite Guru oferece ferramentas estatísticas e análises estratégicas, sem garantia de
              premiação. Todo o conteúdo é destinado a fins de entretenimento. Aposte com responsabilidade.
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default UsoResponsavelPage;
